import React from 'react';
import { MAIN_MOCKUP } from '../data/content';
const particles = Array.from({
  length: 8
}).map((_, i) => ({
  left: `${(i * 7 + i % 3 * 9) % 96}%`,
  duration: `${9 + i % 5 * 2.5}s`,
  delay: `${i % 7 * 1.4}s`,
  size: i % 4 === 0 ? 4 : 2.5,
  opacity: i % 3 === 0 ? 0.9 : 0.55
}));
export function Hero() {
  return <header className="relative vignette overflow-hidden bg-night px-5 pb-6 pt-8 flex flex-col" data-id="element-57" data-mp="4mrteyfb7vk6">
      <div aria-hidden="true" className="absolute inset-0 overflow-hidden" data-id="element-58" data-mp="128fsjr35grze">
        {particles.map((p, i) => <span key={i} className="particle" style={{
        left: p.left,
        width: p.size,
        height: p.size,
        opacity: p.opacity,
        animationDuration: p.duration,
        animationDelay: p.delay
      }} data-id="element-59" data-mp="xbfht2vcv11y" data-mpi={i} />)}
      </div>

      <div className="relative z-10 flex flex-col items-center" data-id="element-60" data-mp="nekm0rqgverd">
        <h1 className="font-display text-[32px] leading-[1.15] font-bold uppercase text-center text-gold-gradient" data-id="element-61" data-mp="3d33fx1m3uzmc">
          Convertí un mate común, en un momento de bienestar 
en solo 5 minutos !!!
        </h1>

        <img id="mockup-principal" src={MAIN_MOCKUP} alt="Ebook El Secreto del Mate Perfecto" loading="eager" decoding="async" {...{
        fetchpriority: 'high'
      }} width={300} height={300} className="mt-4 w-full max-w-[300px] h-auto rounded-md drop-shadow-[0_16px_40px_rgba(62,107,59,0.25)]" data-id="element-62" data-mp="3j9agbasosm43" />
      </div>

      <div className="relative z-10 mt-6 divider-gold" data-id="element-63" data-mp="3eb90qzugz4xd" />
    </header>;
}